﻿import { FC } from "react";
import { Box, Center, VStack, Text } from "@chakra-ui/react";
import { BeatLoader } from "react-spinners";
import { LengthType } from "react-spinners/helpers/props";
import { AbsoluteCenterProps } from "@chakra-ui/react";

type LoadingPageProps = AbsoluteCenterProps & { text: string; size?: LengthType; color?: string };

/**
 * Use this component anytime you are waiting for your entire page to arrive. Use it as your React Suspense fallback and provide
 * a message to the user about what the app is waiting for. You can also use it during app initialization.
 *
 * ```
 * <Suspense fallback={<LoadingPage text={"Loading Components..."} />}>
 *   <Routes>
 *     <Route path="" element={<SomePage/>}/>
 *     ...
 *   </Routes>
 * </Suspense>
 * ```
 *
 * @param text
 * @param size
 * @param color
 */
export const PageLoading: FC<LoadingPageProps> = ({ text, size, color, ...rest }) => (
    <Center height={"100%"} {...rest}>
        <VStack gap={"1rem"}>
            <Box>
                <BeatLoader color={color || "var(--chakra-colors-blue-700)"} size={size || 10} />
            </Box>
            {text && (
                <Box>
                    <Text fontSize="lg">{text}</Text>
                </Box>
            )}
        </VStack>
    </Center>
);

export const LoadingPage = PageLoading;
